import { render, staticRenderFns } from "./LoginInDemo.vue?vue&type=template&id=e4d1e606&scoped=true"
import script from "./LoginInDemo.vue?vue&type=script&lang=js"
export * from "./LoginInDemo.vue?vue&type=script&lang=js"
import style0 from "./LoginInDemo.vue?vue&type=style&index=0&id=e4d1e606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d1e606",
  null
  
)

export default component.exports